/* Add-on folders for the product builder.
 *
 * Each add-on group (Matching Stand, Other Stealth Products, ...) is shown as an
 * iPhone-style folder: a tile with a 2x2 grid of its product photos. Tapping it
 * opens a bubble that grows out of the folder; the group's own tiles move into the
 * bubble, so selection, pre-order pop-ups, pricing and the cart all run through
 * agpb.js exactly as before. Closing moves the tiles back.
 *
 * Why the tiles MOVE rather than being copied: agpb.js handles tile clicks with
 * one listener on the builder root and finds groups with root.querySelector, so
 * the real nodes must stay inside the root. The bubble is therefore built inside
 * the root too.
 *
 * Dependent groups (data-requires-group, e.g. Stand Wheels needs a stand) open in
 * the same bubble as the group they depend on; they get no folder of their own.
 *
 * Progressive: the groups are only hidden once the folders exist (.agpbf-on), so a
 * script failure leaves the normal add-on sections on the page.
 */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function text(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  function groupTitle(group) {
    var t = group.querySelector('.agpb__title');
    if (!t) return '';
    // The title holds a hint span ("Optional ..."); take only its own text.
    var out = '';
    t.childNodes.forEach(function (n) { if (n.nodeType === 3) out += n.textContent; });
    return out.replace(/\s+/g, ' ').trim() || text(t);
  }

  function init(root) {
    var strip = root.querySelector('[data-agpb-folders]');
    if (!strip || strip.getAttribute('data-agpbf-ready')) return;
    strip.setAttribute('data-agpbf-ready', '1');
    var row = strip.querySelector('[data-agpbf-row]');

    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-agpb-group]'));
    if (!groups.length) { strip.hidden = true; return; }

    var byKey = {};
    groups.forEach(function (g) { byKey[g.getAttribute('data-group-key') || ''] = g; });

    // Families: a top-level group plus every group that (transitively) depends on it.
    function topOf(g, depth) {
      var dep = (g.getAttribute('data-requires-group') || '').trim();
      if (!dep || !byKey[dep] || depth > 4) return g;
      return topOf(byKey[dep], depth + 1);
    }
    var families = [];
    groups.forEach(function (g) {
      var top = topOf(g, 0);
      var fam = families.filter(function (f) { return f.top === top; })[0];
      if (!fam) { fam = { top: top, groups: [] }; families.push(fam); }
      fam.groups.push(g);
    });
    // Keep each family in page order, top group first.
    families.forEach(function (f) {
      f.groups.sort(function (a, b) { return a === f.top ? -1 : b === f.top ? 1 : (a.compareDocumentPosition(b) & 4 ? -1 : 1); });
    });

    // ── Bubble (one, shared) ───────────────────────────────────────────
    var scrim = document.createElement('div');
    scrim.className = 'agpbf__scrim';
    scrim.hidden = true;
    var bubble = document.createElement('div');
    bubble.className = 'agpbf__bubble';
    bubble.hidden = true;
    bubble.setAttribute('role', 'dialog');
    bubble.setAttribute('aria-modal', 'true');
    var titleId = 'agpbf-title-' + Math.random().toString(36).slice(2, 8);
    bubble.setAttribute('aria-labelledby', titleId);
    bubble.innerHTML =
      '<div class="agpbf__grab" aria-hidden="true"></div>' +
      '<div class="agpbf__bHead" data-agpbf-drag>' +
        '<h3 class="agpbf__bTitle" id="' + titleId + '"></h3>' +
        '<button type="button" class="agpbf__close" aria-label="Close">' +
          '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="agpbf__bBody" data-agpbf-body></div>' +
      '<div class="agpbf__bFoot"><button type="button" class="agpbf__done" data-agpbf-done>' +
        '<span>Done</span><span class="agpbf__doneTotal" data-agpbf-total></span></button></div>';
    root.appendChild(scrim);
    root.appendChild(bubble);
    var bTitle = bubble.querySelector('.agpbf__bTitle');
    var bBody = bubble.querySelector('[data-agpbf-body]');
    var bTotal = bubble.querySelector('[data-agpbf-total]');

    var totalEl = root.querySelector('.agpb__money--total');
    function syncTotal() { if (bTotal) bTotal.textContent = totalEl ? '· ' + text(totalEl) : ''; }
    if (totalEl && window.MutationObserver) new MutationObserver(syncTotal).observe(totalEl, { childList: true, characterData: true, subtree: true });

    // ── Folders ────────────────────────────────────────────────────────
    families.forEach(function (fam) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'agpbf__folder';
      btn.setAttribute('aria-haspopup', 'dialog');
      btn.setAttribute('aria-expanded', 'false');
      var label = groupTitle(fam.top);
      btn.innerHTML =
        '<span class="agpbf__icon" data-n="0"><span class="agpbf__badge" data-agpbf-badge></span></span>' +
        '<span class="agpbf__label"></span>' +
        '<span class="agpbf__state" data-agpbf-state></span>';
      btn.querySelector('.agpbf__label').textContent = label;
      btn.setAttribute('aria-label', label + ', add-ons');
      row.appendChild(btn);
      fam.btn = btn;
      fam.label = label;

      // A marker before each group so it can go back exactly where it was.
      fam.markers = fam.groups.map(function (g) {
        var m = document.createComment('agpbf');
        g.parentNode.insertBefore(m, g);
        g.classList.add('agpbf-tucked');
        return m;
      });
      fam.top.setAttribute('data-agpbf-family-first', '');

      btn.addEventListener('click', function () { open(fam); });
      updateFolder(fam);
    });

    function picksIn(fam) {
      var n = 0;
      fam.groups.forEach(function (g) {
        if (g.hasAttribute('data-gated-off')) return;
        n += g.querySelectorAll('.agpb__tile--addon[aria-pressed="true"], .agpb__tile--addon.is-active').length;
      });
      return n;
    }
    // Photos of what is on offer right now (a gated group's tiles, e.g. wheels before
    // a stand, are left out), in iPhone-folder squares. Re-drawn only when the set changes.
    function tileSrc(im) {
      var s = im.getAttribute('src') || im.getAttribute('data-src') || '';
      if (!s && im.currentSrc) s = im.currentSrc;
      return s.replace(/([?&])width=\d+/, '$1width=200');
    }
    function renderIcon(fam) {
      var srcs = [];
      fam.groups.forEach(function (g) {
        if (g.hasAttribute('data-gated-off')) return;
        g.querySelectorAll('.agpb__tile--addon img').forEach(function (im) {
          var s = tileSrc(im);
          if (s && srcs.indexOf(s) < 0) srcs.push(s);
        });
      });
      srcs = srcs.slice(0, 4);
      var key = srcs.join('|');
      if (fam.iconKey === key) return;
      fam.iconKey = key;
      var icon = fam.btn.querySelector('.agpbf__icon');
      var badge = icon.querySelector('[data-agpbf-badge]');
      Array.prototype.slice.call(icon.querySelectorAll('.agpbf__cell')).forEach(function (c) { c.remove(); });
      var slots = srcs.length === 1 ? 1 : 4;
      for (var i = 0; i < slots; i++) {
        var cell = document.createElement('span');
        cell.className = 'agpbf__cell' + (srcs[i] ? '' : ' is-empty');
        if (srcs[i]) {
          var img = document.createElement('img');
          img.alt = '';
          img.decoding = 'async';
          img.onload = function () { this.parentNode.classList.add('is-loaded'); };
          img.src = srcs[i];
          cell.appendChild(img);
        }
        icon.insertBefore(cell, badge);
      }
      icon.setAttribute('data-n', String(srcs.length));
    }
    function updateFolder(fam) {
      renderIcon(fam);
      var n = picksIn(fam);
      // Options on offer right now: a gated group (wheels before a stand) does not count.
      var count = fam.groups.reduce(function (k, g) {
        return g.hasAttribute('data-gated-off') ? k : k + g.querySelectorAll('.agpb__tile--addon').length;
      }, 0);
      // Nothing on offer (e.g. Stand Wheels when its stand group is sold out and not on
      // the page): hide the folder rather than show an empty one. It returns if options appear.
      fam.btn.hidden = count === 0 && n === 0;
      fam.btn.classList.toggle('has-picks', n > 0);
      fam.btn.querySelector('[data-agpbf-badge]').textContent = n > 0 ? String(n) : '';
      fam.btn.querySelector('[data-agpbf-state]').textContent = n > 0 ? n + ' added' : '';
    }
    function updateAll() { families.forEach(updateFolder); }
    if (window.MutationObserver) {
      var mo = new MutationObserver(updateAll);
      groups.forEach(function (g) { mo.observe(g, { attributes: true, subtree: true, attributeFilter: ['aria-pressed', 'class', 'hidden', 'data-gated-off'] }); });
    }

    root.classList.add('agpbf-on');

    // ── Open / close ──────────────────────────────────────────────────
    var current = null;
    var lastFocus = null;
    var anim = null;

    function folderRect(fam) {
      var icon = fam.btn.querySelector('.agpbf__icon');
      return (icon || fam.btn).getBoundingClientRect();
    }
    function fromFolderKeyframes(fam) {
      var f = folderRect(fam);
      var b = bubble.getBoundingClientRect();
      var dx = (f.left + f.width / 2) - (b.left + b.width / 2);
      var dy = (f.top + f.height / 2) - (b.top + b.height / 2);
      var s = Math.max(0.08, Math.min(f.width / b.width, f.height / b.height));
      var base = getComputedStyle(bubble).transform;
      base = base && base !== 'none' ? base + ' ' : '';
      return [
        { transform: base + 'translate(' + dx / 1 + 'px,' + dy + 'px) scale(' + s + ')', opacity: 0.35, borderRadius: '22px' },
        { transform: base + 'translate(0,0) scale(1)', opacity: 1 }
      ];
    }

    function lockScroll(on) {
      document.documentElement.classList.toggle('agpb-noscroll', on);
      document.body.classList.toggle('agpb-noscroll', on);
    }

    function open(fam) {
      if (current) return;
      current = fam;
      lastFocus = document.activeElement;
      bTitle.textContent = fam.label;
      fam.groups.forEach(function (g) {
        g.classList.remove('agpbf-tucked');
        g.classList.add('is-open');
        bBody.appendChild(g);
      });
      bBody.scrollTop = 0;
      syncTotal();
      scrim.hidden = false;
      bubble.hidden = false;
      fam.btn.setAttribute('aria-expanded', 'true');
      lockScroll(true);
      requestAnimationFrame(function () { scrim.classList.add('is-on'); });
      if (!REDUCED && bubble.animate) {
        fam.btn.classList.add('is-open');
        anim = bubble.animate(fromFolderKeyframes(fam), { duration: 420, easing: 'cubic-bezier(.2,.9,.25,1.08)' });
        anim.onfinish = function () { anim = null; };
        bBody.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 260, delay: 120, easing: 'ease-out', fill: 'backwards' });
      }
      var first = bubble.querySelector('.agpbf__close');
      if (first) first.focus({ preventScroll: true });
      document.addEventListener('keydown', onKey, true);
    }

    var afterClose = null;
    function finishClose(fam) {
      fam.groups.forEach(function (g, i) {
        var m = fam.markers[i];
        if (m && m.parentNode) m.parentNode.insertBefore(g, m.nextSibling);
        g.classList.add('agpbf-tucked');
      });
      scrim.hidden = true;
      bubble.hidden = true;
      bubble.style.transform = '';
      bubble.style.opacity = '';
      fam.btn.classList.remove('is-open');
      fam.btn.setAttribute('aria-expanded', 'false');
      lockScroll(false);
      updateFolder(fam);
      current = null;
      var then = afterClose; afterClose = null;
      if (then) { then(); return; }
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      // Bounce the folder so the eye lands on the new count.
      if (!REDUCED && fam.btn.animate) {
        fam.btn.querySelector('.agpbf__icon').animate(
          [{ transform: 'scale(.9)' }, { transform: 'scale(1.06)' }, { transform: 'scale(1)' }],
          { duration: 320, easing: 'ease-out' });
      }
    }

    function close() {
      var fam = current;
      if (!fam) return;
      document.removeEventListener('keydown', onKey, true);
      // A pre-order or notify pop-up sits above the bubble; let it finish first.
      scrim.classList.remove('is-on');
      if (anim) { anim.cancel(); anim = null; }
      if (!REDUCED && bubble.animate) {
        var kf = fromFolderKeyframes(fam).reverse();
        var a = bubble.animate(kf, { duration: 260, easing: 'cubic-bezier(.4,0,.6,1)', fill: 'forwards' });
        // Backup: if the animation never reports finishing (tab sent to the background
        // mid-close), finish anyway so the page is never left locked behind a dead bubble.
        var finished = false;
        var fin = function () { if (finished) return; finished = true; a.cancel(); finishClose(fam); };
        a.onfinish = fin;
        setTimeout(fin, 450);
      } else {
        finishClose(fam);
      }
    }

    function modalOpen() {
      // agpb.js pre-order / notify pop-ups and the lightbox stack above the bubble.
      return !!root.querySelector('[data-agpb-preorder-modal]:not(.is-hidden), [data-agpb-notify-modal]:not(.is-hidden), [data-agpb-lightbox]:not(.is-hidden)');
    }

    function onKey(e) {
      if (!current) return;
      if (e.key === 'Escape') {
        if (modalOpen()) return;
        e.preventDefault();
        close();
        return;
      }
      if (e.key === 'Tab') {
        var f = Array.prototype.slice.call(bubble.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
          .filter(function (el) { return el.offsetParent !== null && !el.disabled; });
        if (!f.length) return;
        var firstEl = f[0], lastEl = f[f.length - 1];
        if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
        else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
      }
    }

    /* "Learn more" on a tile jumps to that product's details further down the page
       (agpb.js scrolls there). Close the bubble first, then replay the click so the
       page scrolls with nothing in the way. Links to other pages are left alone. */
    bubble.addEventListener('click', function (e) {
      var link = e.target.closest('.agpb__learnMore');
      if (!link || !current) return;
      if ((link.getAttribute('href') || '').charAt(0) !== '#') return;
      e.preventDefault();
      e.stopPropagation();
      afterClose = function () { link.click(); };
      close();
    }, true);

    scrim.addEventListener('click', close);
    bubble.querySelector('.agpbf__close').addEventListener('click', close);
    bubble.querySelector('[data-agpbf-done]').addEventListener('click', close);

    // Swipe down on the bubble's header (or the grab bar) to close, like a sheet.
    (function () {
      var startY = null, dy = 0;
      var zone = bubble.querySelector('[data-agpbf-drag]');
      var grab = bubble.querySelector('.agpbf__grab');
      function down(e) {
        if (e.target.closest('button')) return;
        startY = (e.touches ? e.touches[0] : e).clientY; dy = 0;
        bubble.style.transition = 'none';
      }
      function move(e) {
        if (startY === null) return;
        dy = Math.max(0, (e.touches ? e.touches[0] : e).clientY - startY);
        var base = getComputedStyle(bubble).transform;
        bubble.style.transform = '';
        base = getComputedStyle(bubble).transform;
        bubble.style.transform = (base && base !== 'none' ? base + ' ' : '') + 'translateY(' + dy + 'px)';
        bubble.style.opacity = String(Math.max(.5, 1 - dy / 600));
      }
      function up() {
        if (startY === null) return;
        startY = null;
        bubble.style.transition = '';
        if (dy > 90) { bubble.style.transform = ''; bubble.style.opacity = ''; close(); }
        else {
          bubble.style.transform = '';
          bubble.style.opacity = '';
        }
      }
      [zone, grab].forEach(function (z) {
        if (!z) return;
        z.addEventListener('touchstart', down, { passive: true });
        z.addEventListener('touchmove', move, { passive: true });
        z.addEventListener('touchend', up);
        z.addEventListener('touchcancel', up);
      });
    })();
  }

  function boot() {
    // In the theme editor keep the normal sections so their blocks can be clicked and edited.
    if (window.Shopify && window.Shopify.designMode) return;
    document.querySelectorAll('.agpb').forEach(function (root) {
      // Wait for agpb.js to finish wiring the groups (it adds agpb--ready).
      if (root.classList.contains('agpb--ready')) { init(root); return; }
      var tries = 0;
      var t = setInterval(function () {
        tries++;
        if (root.classList.contains('agpb--ready') || tries > 60) { clearInterval(t); init(root); }
      }, 100);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
